import * as React from "react"

import Layout from "../components/Layout"
import Seo from "../components/Seo"

import Header from "../components/services/Header"
import ServiceSection, {
  ServiceType,
} from "../components/services/ServiceSection"
import Slice from "../components/Slice"

import { graphql, useStaticQuery } from "gatsby"
import { getImage, IGatsbyImageData } from "gatsby-plugin-image"

const ServicesPage = (props) => {
  const ImageDataQuery = graphql`
    query {
      allImageSharp(
        filter: { fixed: { originalName: { regex: "/service/" } } }
        sort: { fields: fixed___originalName }
      ) {
        edges {
          node {
            gatsbyImageData(
              layout: CONSTRAINED
              quality: 100
              placeholder: TRACED_SVG
            )
          }
        }
      }
    }
  `

  const imageQuery = useStaticQuery(ImageDataQuery)

  const getImageArray = (substring: string) => {
    const images = imageQuery.allImageSharp.edges
    const imgArray: (IGatsbyImageData | undefined)[] = []
    images.forEach((image) => {
      const source = image.node.gatsbyImageData.images.sources[0].srcSet
      if (source.includes(substring)) {
        imgArray.push(getImage(image.node))
      }
    })

    return imgArray
  }

  const services: ServiceType[] = [
    {
      id: "ladies",
      title: "Ladies.",
      description:
        "A ladies-only group for swimmers over the age of 18, who want to work on a fitter lifestyle in a man-free environment. The morning sessions offer a perfect way to get your day started.",
      minClasses: 1,
      maxClasses: 3,
      billTerm: "termly",
      enquireLink: "",
      images: getImageArray("ladies"),
      textPlacement: "left",
    },
    {
      id: "masters",
      title: "Masters.",
      description:
        "This group is perfect for anyone over the age of 18, who wants to focus on living a healthier, fitter lifestyle. Use your swimming session as a wake-up session before work, or as a wind-down session after work.",
      minClasses: 1,
      maxClasses: 4,
      billTerm: "termly",
      enquireLink: "",
      images: getImageArray("masters"),
      textPlacement: "right",
    },
  ]

  const heroImages = getImageArray("hero")
  return (
    <Layout>
      <Seo title="Services" />
      <Header images={heroImages} />
      {services.map((service, index) => (
        <ServiceSection
          key={"service-section-" + service.id}
          id={service.id}
          title={service.title}
          description={service.description}
          minClasses={service.minClasses}
          maxClasses={service.maxClasses}
          billTerm={service.billTerm}
          enquireLink={service.enquireLink}
          images={service.images}
          textPlacement={service.textPlacement}
        />
      ))}
      <Slice color="#222222" />
    </Layout>
  )
}

export default ServicesPage
